/*
* 阔地教育科技有限公司版权所有（codyy.com/codyy.cn）.
* Copyright (c) 2019, Codyy and/or its affiliates. All rights reserved.
* @Date: 2020.02.25 10:19.
* @Author
* @Description 辽宁点播项目 - 点播列表
**/
<template>
    <div class="ln-query">
        <!-- 查询条件 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">

            <el-form-item label="年级：">
                <el-select @change="handleQueryChange" placeholder="请选择年级" v-model="formInline.gradeVal">
                    <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in gradeList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="学科：">
                <el-select @change="handleQueryChange" placeholder="请选择学科" v-model="formInline.subjectVal">
                    <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in subjectList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="版本：">
                <el-select @change="handleQueryChange" placeholder="请选择版本" v-model="formInline.editionVal">
                    <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in editionList"></el-option>
                </el-select>
            </el-form-item>

            <!--            <el-form-item label="分类">-->
            <!--                <el-select @change="handleQueryChange" placeholder="请选择分类" v-model="formInline.classificationVal">-->
            <!--                    <el-option :key="item.name" :label="item.name" :value="item.name" v-for="item in classificationList"></el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="子分类">-->
            <!--                <el-select @change="handleQueryChange" placeholder="子分类" v-model="formInline">-->
            <!--                    <el-option label="区域一" value="shanghai"></el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->
        </el-form>
        <!-- 课程列表 -->
        <ul class="ln-list" v-if="list.length > 0">
            <li :key="item.id" @click="handleVideoClick(item)" v-for="item in list">
                <img :src=item.url alt=""/>
                <h3>{{ item.resourceName }}</h3>
                <p><span>{{ item.realname }}</span> {{ item.createTimeStr }}</p>
            </li>
        </ul>
        <div class="no-data" v-else>
            暂无数据~~
        </div>
        <!-- 分页 -->
        <el-pagination :current-page="listQuery.pageNum" :hide-on-single-page="true" :page-size="listQuery.pageSize" :pager-count="5"
                       :total="total" @current-change="getListData" background layout="prev, pager, next, jumper">
        </el-pagination>
    </div>
</template>

<script>
import { listData } from '@/api' // 接口
import { gradeData, subjectData, editionData } from '@/api/data.js'

export default {
  name: 'VideoList',
  data () {
    return {
      list: [],
      total: 0,
      formInline: {
        gradeVal: '0',
        subjectVal: '0',
        editionVal: '0',
      },
      gradeList: [],
      subjectList: [],
      editionList: [],
      classificationList: [],

      listQuery: {
        pageNum: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
      },
    }
  },
  created () {
    this.getListData() // 动态获取数据
    this.gradeList = gradeData
    this.subjectList = subjectData
    this.editionList = editionData
  },
  methods: {
    /**
     *@Description
     *@Param
     *@Return 列表接口.
     **/
    getListData (e) {
      let params = {
        pageNum: e || this.listQuery.pageNum, // 当前页数
        pageSize: this.listQuery.pageSize, // 每页显示多少条
        baseSubjectId: this.formInline.subjectVal == 0 ? '' : this.formInline.subjectVal, // 学科
        baseVersionId: this.formInline.editionVal == 0 ? '' : this.formInline.editionVal, // 版本
        baseClasslevelId: this.formInline.gradeVal == 0 ? '' : this.formInline.gradeVal, // 年级
      }
      console.time('videoList')
      listData(params).then(res => {
        console.log('res', res)
        if (res.result) {
          console.log('res', res, res.result)
          res.result.forEach(val => {
            const time = val.createTimeStr.split(' ')
            val.url = 'http://lncyjyjrescdn.ppms.cn/reserver/' + val.thumbPath
            val.createTimeStr = time[0]
          })
          this.list = res.result
        } else {
          this.list = []
          console.log('this.list****', this.list)
        }
        console.timeEnd('videoList')
        this.total = res.totalNum
      })
    },
    /**
     *@Description
     *@Param
     *@Return change 查询条件时 更新数据列表.
     **/
    handleQueryChange () {
      this.getListData() // 动态获取数据
    },
    /**
     *@Description
     *@Param
     *@Return 课程点击事件.
     **/
    handleVideoClick (item) {
      // this.$router.push('/play')
      console.log('item', item)
      this.$router.push({
        path: '/play',
        query: {
          id: item.resourceId,
        }
      })
    },
    /**
     *@Description
     *@Param
     *@Return 分页函数.
     **/
    handleCurrentChange (e) {
      this.listQuery.pageNum = e
      this.getListData() // 动态获取数据
    },
  }
}
</script>
<style lang="scss">
    /* ios select 点击两次才触发 */
    .el-scrollbar {
        > .el-scrollbar__bar {
            opacity: 1 !important;
        }
    }
    .w100 {
        .el-pagination__jump {
            display: none !important;
        }
    }
</style>
<style lang="scss" scoped>
    .ln-query {
        margin-bottom: 20px;
    }
    .ln-list {
        overflow: hidden;
        padding: 10px 0 20px 0;
        li {
            float: left;
            width: 218px;
            height: 185px;
            margin-left: 1px;
            padding: 10px;
            cursor: pointer;
            &:hover {
                box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
            }
            img {
                display: block;
                width: 100%;
                height: 115px;
                background: #eee;
            }
            h3 {
                font-size: 16px;
                font-weight: normal;
                overflow: hidden;
                margin-top: 5px;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #444444;
            }
            p {
                font-size: 12px;
                line-height: 20px;
                padding: 5px 0;
                color: #999;
            }
            span {
                display: inline-block;
                overflow: hidden;
                width: 100px;
                vertical-align: middle;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
    .no-data {
        line-height: 100px;
        text-align: center;
        border: 1px solid #dcdcdc;
    }
    /* 移动端 */
    .w100 {
        .ln-query {
            margin-top: 10px;
        }
    }
    @media screen and (min-width: 600px) and (max-width: 1024px) {
        .w100 {
            .ln-list {
                margin-right: -20px;
                li {
                    float: left;
                    overflow: hidden;
                    width: calc(50% - 20px);
                    margin-right: 20px;
                }
            }
        }
    }

</style>
